'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'radio-tuner';
var width = 512;
var height = 512;
var aliases = ["radio-alt"];
var unicode = 'f8d8';
var svgPathData = 'M494.3 15.2l23.2-6-12-46.5-23.2 6-464 120-18 4.7 0 386.6 512 0 0-384-330.3 0 312.3-80.8zM48.2 144l416 0 0 48-416 0 0-48zm416 96l0 192-416 0 0-192 416 0zm-32 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-312 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm136-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRadioTuner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;